<template>
  <div class="edu-history-modal" ref="modalContainerRef">
    <div class="modal-content">
      <div class="modal-title">
        <img class="logo" src="@/assets/images/edu/img_logo_2.webp" alt="logo" />
        <span class="title">接下来，让我们一起回顾下你在课堂上的创作！</span>
      </div>
      <div class="modal-body">
        <div class="body-inner">
          <div v-for="item in recentlyFourHistory" :key="item.id" class="inner-item">
            <AppImage :src="item.images[0].imageResize512Url" />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div ref="tipsRef" class="tips"></div>
        <AppButton @clickEvent="handleClick">查看历史 继续创作</AppButton>
      </div>
      <div class="icon-close" @click="props.onClose">
        <span class="hitems-close"></span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import AppButton from '@/components/AppButton/index.vue'
  import AppImage from '@/components/AppImage.vue'
  import { onMounted, onBeforeUnmount, ref } from 'vue'
  import httpApi from '@/http/api'
  import { useRouter } from 'vue-router'
  defineOptions({
    name: 'EduHistoryModal'
  })

  const router = useRouter()
  const tipsRef = ref<HTMLElement>()
  const recentlyFourHistory = ref<any[]>([])
  const modalContainerRef = ref<HTMLElement>()

  const props = defineProps<{
    onClose: () => void
  }>()

  onMounted(() => {
    if (tipsRef.value) {
      tipsRef.value.innerText =
        '还意犹未尽？继续发挥想象力吧\n还可以把你的创意做成实物，在班级内分享！\n实践活动也在这里完成哦~ (ˊᗜˋ*)'
    }

    if (modalContainerRef.value) {
      modalContainerRef.value.addEventListener('wheel', handleWheel, { passive: false })
    }

    getHistory()
  })

  onBeforeUnmount(() => {
    if (modalContainerRef.value) {
      modalContainerRef.value.removeEventListener('wheel', handleWheel)
    }
  })

  const handleWheel = (e: WheelEvent) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const getHistory = async () => {
    const res = await httpApi.getHistoryList(1, 'image')
    recentlyFourHistory.value = res.data.dataList.slice(0, 4)
  }

  const handleClick = () => {
    props.onClose()
    router.push('/account')
    localStorage.setItem('showHistoryGuide', 'true')
  }
</script>

<style lang="stylus" scoped>
  @import './index.styl'
</style>
